module.exports = __webpack_public_path__ + "0ecee663a0193d739c46d5ad1728a22b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/camp7.jpeg
// module id = 1141
// module chunks = 0